module.exports = __webpack_public_path__ + "img/wastetop_orange.min.48f31da6.png";